<h2 mat-dialog-title>{{ 'WORK_ORDER.ORDER_FORM.UNSAVED_CHANGES' | translate }}</h2>
<mat-dialog-content>
  {{ 'WORK_ORDER.ORDER_FORM.UNSAVED_WARNING' | translate }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="dialogRef.close(WorkOrderUnsavedChangesDialogResult.DISCARD_CHANGES)">
    {{ 'WORK_ORDER.ORDER_FORM.LEAVE' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="continueEditing()">
    {{ 'WORK_ORDER.ORDER_FORM.STAY' | translate }}
  </button>
</mat-dialog-actions>
